import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  whiteColor: {
    color: theme.palette.common.white,
  },
  primaryColor: {
    color: COLOR_PURPLE,
  },
  mainContentBox: {
    backgroundColor: COLOR_PURPLE,
    backgroundImage: 'url("/images/institutions/background-image-refer-academic-institution.svg")',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  textRefer: {
    fontSize: 28,
    color: theme.palette.common.white,
    padding: theme.spacing(1, 0, 4),
  },
  textInsertEmail: {
    fontSize: 30,
    color: theme.palette.common.white,
    padding: theme.spacing(2, 0),
  },
  input: {
    width: 500,
    fontSize: 20,
    marginBottom: theme.spacing(2),
    color: theme.palette.common.white,

    '&:hover': {
      '&::before': {
        borderColor: `${theme.palette.common.white} !important`,
      },
    },

    '&::before, &::after': {
      borderColor: theme.palette.common.white,
    },
  },
  inputText: {
    textAlign: 'center',
  },
  inputFocused: {
    '&::after': {
      borderColor: `${theme.palette.grey[400]} !important`,
    },
  },
  inputLabel: {
    color: theme.palette.common.white,
  },
  inputLabelFocused: {
    color: '#FFF !important',
  },
}));
